import { render, staticRenderFns } from "./RegisterMuatUpload.vue?vue&type=template&id=33d5ecc4&scoped=true&"
import script from "./RegisterMuatUpload.vue?vue&type=script&lang=js&"
export * from "./RegisterMuatUpload.vue?vue&type=script&lang=js&"
import style1 from "./RegisterMuatUpload.vue?vue&type=style&index=1&id=33d5ecc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d5ecc4",
  null
  
)

export default component.exports